import { useCallback } from 'react';
import { useBookingGate } from '@/context/BookingGateContext';
import { hasDirectBookingCalendar, resolveBookingUrl } from '@/lib/utils';

export const useBookingCallToAction = (configuredUrl?: string) => {
  const bookingUrl = resolveBookingUrl(configuredUrl);
  const directBookingEnabled = hasDirectBookingCalendar(configuredUrl);
  const { open } = useBookingGate();

  const triggerBooking = useCallback(() => {
    if (directBookingEnabled) {
      open(bookingUrl);
      return;
    }

    if (typeof window !== 'undefined') {
      window.location.href = bookingUrl;
    }
  }, [bookingUrl, directBookingEnabled, open]);

  return {
    bookingUrl,
    directBookingEnabled,
    triggerBooking,
  };
};
